module.exports = __webpack_public_path__ + "images/top_icon_search_white.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/top_icon_search_white.png
// module id = 906
// module chunks = 127